import { $axios } from "../config/axios";
import newAxios from "axios";
const richDataAxios = newAxios.create({});
export default {
  getProfilePictureAWSS3URL(params) {
    return $axios.get("/profile/company-logo-upload-url");
  },
  saveProfilePictureToTargetUrl(targetUrl, file, params = {}) {
    return richDataAxios.put(targetUrl, file);
  },
  informUploadStatusToBackend(fileId) {
    return $axios.patch(`/profile/company-logo-upload/${fileId}`);
  },

  fetchZipReportsData({ responseType, ...params }) {
    return $axios.get(`/download-reports`, { params, responseType });
  },
};
